import { Moon, Sun } from "lucide-react";
import { Button } from "@marekl/adminer/components";
import { applyTheme, type ThemeMode } from "./theme";
import { useThemeMode } from "./useThemeMode";

/**
 * Switches the admin between day shift and night mail. It sits in the Topbar's
 * right slot, next to the instance tag.
 *
 * With no stored choice the OS decides, so the button follows the system theme
 * live until someone picks a side.
 */
export function ThemeToggle() {
  const mode = useThemeMode();

  function toggle() {
    const next: ThemeMode = mode === "night" ? "day" : "night";
    applyTheme(next);
  }

  return (
    <Button
      variant="neutral"
      weight="ghost"
      iconOnly
      startIcon={mode === "night" ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
      onClick={toggle}
      aria-label={mode === "night" ? "Switch to day shift" : "Switch to night mail"}
      title={mode === "night" ? "Day shift" : "Night mail"}
    />
  );
}
